import { configFetch as fetch } from '@meiqia/utils';

export const getTranslationQuota = () => {
  return fetch({
    url: '/unified-api/conversations/v1/conversation/translate/config',
    method: 'get'
  });
};
